export function Set(name: string, value: string, days: number = 7, path: string = '/') {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`;
}

export function Get(name: string): string | undefined {
    const match = new RegExp(`(^| )${name}=([^;]+)`).exec(document.cookie);
    if (match) {
        return decodeURIComponent(match[2]);
    }
}